<template>
    <div class="sidebar__section sidebar__section--medium-vertical-padding">
            <div class="locked-info copy-light">
                <Icon :size="32"><IconLock /></Icon>
                <div class="locked-info__text">
                    Für diese Inhalte ist ein Login erforderlich.
                </div>
                <a href="#" class="locked-info__link" @click="loginClickHandler">Jetzt einloggen</a>
            </div>
        </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import Icon from '@/components/Icon.vue'
import IconLock from '@/components/icons/IconLock.vue'

export default {
    components: {
        Icon,
        IconLock
    },
    methods: {
        loginClickHandler(e) {
            e.preventDefault()
            eventBus.$emit('showLoginMenu')
        },
    }
}
</script>

<style lang="scss">
.locked-info {
    text-align: center;

    &__text {
        margin: 0 auto;
        padding: 24px 0;
        max-width: 250px;

        @include mq(tablet) {
            padding: 16px 0 8px;
        }
    }

    &__link {
        font-weight: $font-weight-medium;
    }
}
</style>